import { render, staticRenderFns } from "./CourseOutcomeExcel.vue?vue&type=template&id=f5728c64"
import script from "./CourseOutcomeExcel.vue?vue&type=script&lang=js"
export * from "./CourseOutcomeExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports